import {createFeatureSelector, createSelector, MemoizedSelector} from "@ngrx/store";
import {PROFILE_STATE_NAME, ProfileState} from "./profile";

export const selectProfileState = createFeatureSelector<ProfileState>(PROFILE_STATE_NAME);

export const selectProfile = createSelector(
  selectProfileState,
  (state: ProfileState) => state.profile
);

export const selectProfileLoading: MemoizedSelector<object, boolean> = createSelector(
  selectProfileState,
  (state: ProfileState): boolean => state.profileLoading
);

export const selectProfileModeLoading: MemoizedSelector<object, boolean> = createSelector(
  selectProfileState,
  (state: ProfileState): boolean => state.modeLoading
)

export const selectProfileAvatar = createSelector(
  selectProfileState,
  (state: ProfileState) => state.profile.attributes.avatar_url
);
